@if (visible()) {
<kendo-dialog (close)="close()" [width]="'95vw'" [height]="'90vh'" [minWidth]="'800px'"
  [maxWidth]="'1400px'">
  <kendo-dialog-titlebar>{{ title() }}</kendo-dialog-titlebar>

  <div class="d-flex justify-content-start mb-2">
    <button type="button" kendoButton class="cyflare-btn-secondary" [disabled]="isExporting()"
      (click)="exportCsv()">
      Download CSV
    </button>
  </div>

  @if (url(); as endpoint) {
  <div class="table-responsive w-100">
    <app-datatable [data-href]="endpoint" [columns]="datatableColumns()" [useOData]="true"></app-datatable>
  </div>
  }
</kendo-dialog>
}
